import {FEATURE_TOGGLE_NAMES} from '../../../modules/feature-toggle/featureToggleConstants';

const GLOBAL_FEATURE_TOGGLES = [
  FEATURE_TOGGLE_NAMES.ENABLE_GTM,
  FEATURE_TOGGLE_NAMES.HIDE_JS_FROM_GOOGLEBOT,
  FEATURE_TOGGLE_NAMES.DISPLAY_HEPSIGLOBAL_MODAL,
  FEATURE_TOGGLE_NAMES.REMOVE_VOLTRAN_SCRIPTS_INITIAL_LOAD,
  FEATURE_TOGGLE_NAMES.ENABLE_DESKTOP_STICKY_VERTICAL_FILTER_FROM_PWA,
  FEATURE_TOGGLE_NAMES.IS_CRITICAL_CSS,
  FEATURE_TOGGLE_NAMES.SHOW_PLP_REDESIGN_LAYOUT
];

const DESKTOP_CATEGORY_PAGE_FEATURE_TOGGLES = [
  ...GLOBAL_FEATURE_TOGGLES,
  FEATURE_TOGGLE_NAMES.SERVER_SIDE_RENDER_FOR_PWA_DESKTOP_CATEGORY_PAGE,
  FEATURE_TOGGLE_NAMES.SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_DESKTOP_CATEGORY_PAGE,
  FEATURE_TOGGLE_NAMES.DISPLAY_DICTIONARY_CONTENT_FOR_PWA_DESKTOP_PAGES,
  FEATURE_TOGGLE_NAMES.PAGE_LIMIT_IN_LISTING_PAGES,
  FEATURE_TOGGLE_NAMES.DISPLAY_PWA_DESKTOP_CATEGORY_PAGES_FROM_CMS,
  FEATURE_TOGGLE_NAMES.DISPLAY_BANNER_ENABLED_FOR_DESKTOP_CATEGORY_PAGE,
  FEATURE_TOGGLE_NAMES.DISPLAY_RECO_PRODUCTS_FOR_CATEGORY_PAGE,
  FEATURE_TOGGLE_NAMES.DISPLAY_FEEDBACK_PWA_DESKTOP,
  FEATURE_TOGGLE_NAMES.DISPLAY_COMPARED_TOP_SELLER_PRODUCTS_CATEGORY,
  FEATURE_TOGGLE_NAMES.DISPLAY_POPULAR_SEARCH_KEYWORDS_ON_CATEGORY_PAGE,
];

const DESKTOP_SEARCH_PAGE_FEATURE_TOGGLES = [
  ...GLOBAL_FEATURE_TOGGLES,
  FEATURE_TOGGLE_NAMES.SERVER_SIDE_RENDER_FOR_PWA_DESKTOP_SEARCH_PAGE,
  FEATURE_TOGGLE_NAMES.SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_DESKTOP_SEARCH_PAGE,
  FEATURE_TOGGLE_NAMES.DISPLAY_SPONSORED_BRAND_FOR_PWA_DESKTOP,
  FEATURE_TOGGLE_NAMES.DESKTOP_PAGE_LIMIT_IN_SEARCH,
  FEATURE_TOGGLE_NAMES.DISPLAY_BANNER_ENABLED_FOR_DESKTOP_SEARCH_PAGE,
  FEATURE_TOGGLE_NAMES.DISPLAY_FEEDBACK_PWA_DESKTOP,
  FEATURE_TOGGLE_NAMES.DISPLAY_COMPARED_TOP_SELLER_PRODUCTS_SEARCH,
  FEATURE_TOGGLE_NAMES.DISPLAY_POPULAR_SEARCH_KEYWORDS_ON_SEARCH_PAGE,
];

const DESKTOP_TAG_PAGE_FEATURE_TOGGLES = [
  ...GLOBAL_FEATURE_TOGGLES,
  FEATURE_TOGGLE_NAMES.SERVER_SIDE_RENDER_FOR_PWA_DESKTOP_TAG_PAGE,
  FEATURE_TOGGLE_NAMES.SERVER_TO_CLIENT_SEND_INITIAL_DATA_FOR_PWA_DESKTOP_TAG_PAGE,
  FEATURE_TOGGLE_NAMES.DISPLAY_BANNER_ENABLED_FOR_DESKTOP_TAG_PAGE,
  FEATURE_TOGGLE_NAMES.DISPLAY_RECO_PRODUCTS_FOR_DESKTOP_TAG_PAGE,
];

export {
  DESKTOP_CATEGORY_PAGE_FEATURE_TOGGLES,
  DESKTOP_SEARCH_PAGE_FEATURE_TOGGLES,
  DESKTOP_TAG_PAGE_FEATURE_TOGGLES
}
